import { Stack, Typography } from '@mui/material'
import { styled } from '@mui/system'
import { withPrefix } from 'gatsby'
import * as React from 'react'
import { useIntl } from 'react-intl'

const Rootdiv = styled(Stack)({
  height: "600px",
  borderTop: "1px solid #56584e",
  padding: "20px 0 0 25px",
  flexWrap: "wrap",
})

const Item = styled('div')({
  position: "relative",
  zIndex: "5000",
  width: "160px",
  height: "255px",
  margin: "32px 32px 0 0",
})

const NamePeople = styled(Typography)({
  backgroundColor: "#E6142D",
  position: "absolute",
  color: "white",
  overflow: "hidden",
  top: "128px",
  left: "0px",
  width: "100px",
  height: "100px",
  padding: "17px 5px 0 10px",
  fontSize: "15px",
  fontWeight: "600",
})

const DivHover = styled(Stack)({
  backgroundColor: "#E6142D",
  color: "white",
  position: "absolute",
  width: "100%",
  height: "100%",
  top: "0px",
  left: "0px",
  padding: "16px 0 0px 12px",
  zIndex: "6000",
  opacity: "0",
  transition: "0.2s",
  cursor: "pointer",
  overflow: "hidden",
  '&:hover, &.Mui-focusVisible':{
    opacity: "1",
  }
})

const TitleHover = styled(Typography)({
  width: "100%",
  height: "20%",
  fontSize: "16px",
  fontWeight: "800",
})

const TextHover = styled(Typography)({
  margin: "16px 0 30px 0",
  overflow: "auto",
  maxLines: "8",
  fontSize: "12px",
  fontWeight: "500",
  '&::-webkit-scrollbar': {
    display: "none",
  },
})

const BottomLink = styled(Typography)({
  position: "absolute",
  bottom: "0px",
  left: "0px",
  textAlign: "right",
  height: "25px",
  padding: "6px 10px 0 0",
  backgroundColor: "#303030",
  width: "100%",
  color: "white",
  fontSize: "12px",
  fontWeight: "700",
})

export default function ItemPeopleList (props) {
  const intl = useIntl()

  return (
    <Rootdiv direction="column" sx={{width: (Math.round(props.peoples.length / 2) * 192) + "px"}}>
      {props.peoples.map((people, i) => (
        <Item key={people.firstname + people.lastname}>
          <img src={withPrefix(`/images/thumbnail/` + people.thumbnail)} alt={people.firstname}/>
          <NamePeople variant="h4">
            {people.firstname + " " + people.lastname}
          </NamePeople>
          <DivHover onClick={() => {props.handleClick(people)}} variant="column" justifyItems="center">
            <TitleHover variant="h5">
              {people.firstname + " " + people.lastname}
            </TitleHover>
            <TextHover variant="body1">
              {people.translations.find((translat) => (translat.lang === intl.locale)).excerpt}
            </TextHover>
            <BottomLink variant="body2">
              {intl.formatMessage({ id: "seePortrait" })}
            </BottomLink>
          </DivHover>
        </Item>
      ))}
    </Rootdiv>
  )
}